<template>
  <div class="main-container">
    <div class="item settlement-status" v-if="infoForm.id">
      结算状态：
      <div v-if="infoForm.settlementStatus == 0" class="tag-settled">未结算</div>
      <div v-else class="tag-be">已结算</div>
    </div>

    <div @click="foldBtn(1)" class="foldblock">
      <Icon :type="fold ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
      <span class="title">基本信息</span>
    </div>
    <Form :model="infoForm" ref="infoFormRef" class="page-form form-container" :label-width="90" v-show="fold">
      <FormItem label="结算单名称" prop="reportName" :rules="$units.formRule.required('请输入结算单名称')">
        <Input type="text" v-model="infoForm.reportName" placeholder="请输入" />
      </FormItem>

      <FormItem label="结算机构" prop="orgIds" :rules="$units.formRule.arrRequired('请选择结算机构', (trigger = 'change'))">
        <selectTree
          @change="changeTreeOrg"
          v-model="infoForm.orgIds"
          type="4"
          :maxTagCount="1"
          :multiple="true"
          :isTopCheck="true"
          :disabled="nextData.settled"
          ref="selectTreeRef"
        >
        </selectTree>
      </FormItem>

      <FormItem label="结算周期" prop="settlementDate" :rules="$units.formRule.required('请选择结算日期')">
        <DatePicker
          type="date"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          @on-change="infoForm.settlementDate = $event"
          :value="infoForm.settlementDate"
          :disabled="nextData.settled"
        ></DatePicker>
      </FormItem>

      <FormItem label="备注" prop="remark">
        <Input type="textarea" v-model="infoForm.remark" placeholder="请输入" />
      </FormItem>
    </Form>
    <Divider />

    <div @click="foldBtn(2)" class="foldblock">
      <Icon :type="foldData ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
      <span class="title">待结算数据</span>
    </div>

    <div v-show="foldData">
      <div class="search-tools">
        <div class="search-box btn3">
          <div class="input-item">
            <span class="label">保单号</span>
            <Input v-model="search.policyNo" clearable placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">批单号</span>
            <Input v-model="search.billNo" clearable placeholder="请输入" />
          </div>

          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" class="btn-reset" @click="rese()">重置</Button>
        </div>
      </div>

      <div class="statistics-container">
        <div class="statistics-item">
          <span>汇总数据：</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>保单数：</span>
          <span class="num">{{ statisticsData.policyNum }}</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>批单数：</span>
          <span class="num">{{ statisticsData.billNum }}</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>保费：</span>
          <span class="num">{{ statisticsData.sumFee }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>净收入：</span>
          <span class="num">{{ statisticsData.sumNetIncome }}元</span>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >条，共<span>{{ total }}</span
            >条数据</span
          >
        </div>
      </div>

      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" v-if="infoForm.settlementStatus == 0 && row.isDeduct == '0'" @click="changeCommission(row)">修改费用</span>
            <span class="table-btn" v-if="row.isDeduct == 1 && infoForm.settlementStatus == 0" @click="withholdingCommission(row, true)">修改扣款</span>

            <span class="table-btn-disabled" v-if="nextData.settled">删除</span>
            <span class="table-btn" @click="delRow([row.id])" v-else>删除</span>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
      </div>
    </div>
    <div style="height: 110px"></div>

    <div class="footer-action">
      <div>
        <Button type="primary" class="btn" @click="save(false, 0, false)" :loading="saveLoading">保存</Button>
        <Button type="primary" ghost @click="back('/orgSettlement/groupCommissionSettlement')">返回</Button>
        <Button type="primary" ghost @click="save(true, 5)" :disabled="nextData.settled">选择对账单</Button>
        <Dropdown :transfer="true" @on-click="dropdownClick($event)" style="margin-left:10px">
          <Button type="primary" ghost :disabled="nextData.settled">选择保/批单</Button>
          <template #list>
            <DropdownMenu>
                <DropdownItem name="search">按条件检索数据</DropdownItem>
                <DropdownItem name="allSearch">输入保单号批量选择</DropdownItem>
            </DropdownMenu>
        </template>
        </Dropdown>
        <Button type="primary" ghost @click="save(true, 3)" :disabled="nextData.settled">Excel导入结算数据</Button>
        <Button type="primary" ghost @click="batchDelete" :disabled="nextData.settled">批量删除</Button>
        <Button type="primary" ghost @click="save(true, 1, false)" v-if="!nextData.settled" :loading='nextStepLoading'>下一步</Button>
        <Button type="primary" ghost @click="settledNextStep" v-else>下一步</Button>
        <Button type="primary" ghost @click="exportTable">导出结算数据</Button>
      </div>
    </div>

    <!-- 选择保单 -->
    <selectPolicyPopUp ref="selectPolicyRef" :reportId="reportId" @success="searchAjax"></selectPolicyPopUp>

    <!-- 修改费用 -->
    <modifyCommission ref="modifyCommissionRef" @success="searchAjax"></modifyCommission>

    <selectSettlementData ref="selectSettlementData" :reportId="reportId" @success="searchAjax"></selectSettlementData>

    <!-- 选择对账单 -->
    <selectStatement ref="selectStatement" @success="searchAjax"> </selectStatement>

    <!-- 批量导入 -->
    <import-tool ref="importTool" @success="searchAjax" @exportTable="exportTable"></import-tool>

    <!-- 修改扣款 -->
    <group-commission-modify ref="commissionModify" @success="searchAjax"></group-commission-modify>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import importTool from '../components/importTool';
import selectTree from '@/components/system/selectTree3';
import selectStatement from '../components/selectStatement';
import selectPolicyPopUp from '../components/selectPolicyPopUp';
import modifyCommission from '../components/modifyCommission';
import selectSettlementData from '../components/selectSettlementData';
import groupCommissionModify from '../../commissionSettlementQuery/components/groupCommissionModify';

export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    selectPolicyPopUp,
    modifyCommission,
    selectSettlementData,
    importTool,
    groupCommissionModify,
    selectStatement
  },
  props: {
    nextData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      saveLoading: false,
      nextStepLoading: false,
      fold: true,
      foldData: true,
      isAdd: 0,
      infoForm: {
        settlementDate: ''
      },
      search: {},
      statisticsData: {
        policyNum: 0,
        billNum: 0,
        sumFee: 0,
        sumNetIncome: 0
      },
      total: 0,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          fixed: 'left',
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 120
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费(元)',
          align: 'center',
          key: 'fee',
          minWidth: 150
        },
        {
          title: '费用归属/机构',
          align: 'center',
          key: 'owerName',
          minWidth: 200
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'commissionType ',
          minWidth: 160,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if (commissionType == 1 || commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }
          }
        },
        {
          title: '净费率',
          align: 'center',
          key: 'netCommission',
          minWidth: 100,
          render(h, params) {
            const netCommission = params.row.netCommission;
            return <span>{netCommission ? netCommission + '%' : '-'}</span>;
          }
        },
        {
          title: '净收入',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            const netIncome = params.row.netIncome;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{netIncome ? netIncome : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{netIncome ? netIncome : '-'}</span>;
            }
          }
        },
        {
          title: '出单人',
          align: 'center',
          key: 'salesmanName',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 140,
          fixed: 'right'
        }
      ],
      orgIds:[],
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      reportId: null
    };
  },
  created() {
    this.isAdd = this.$route.query.isAdd;
    this.reportId = this.$route.query.reportId;
    let today = new Date();
    this.infoForm.settlementDate = filter.filterTime(today, 'YYYY-MM-DD');
  },
  activated() {
    if (this.isAdd == 0 && this.reportId) {
      this.getDetailData();
      this.searchAjax();
    }
  },
  methods: {
    getData() {
      this.reportId = this.nextData.reportId;
      this.getDetailData();
      this.searchAjax();
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
      this.getDetailData();
    },

    // 更多操作
    dropdownClick(name, row) {
      if (name == 'search') {
        this.save(true, 2)
      } else if (name == 'allSearch') {
        this.save(true, 4)
      }
    },

    // 重置
    rese() {
      this.search = {};
      this.searchAjax();
    },

    // 获取详情
    getDetailData() {
      this.$http({
        url: '/buz/settlementReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.infoForm = res.data;
        this.orgIds = res.data.orgIds;
        this.$nextTick(() => {
          this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        });
      });
    },

    // 获取列表
    getList() {
      if (!this.reportId) {
        return;
      }
      this.listLoading = true;
      this.$http({
        url: '/buz/settlementData/read/page',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          reportId: this.reportId,
          ...this.search
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 获取统计
    getStatisticsData() {
      if (!this.reportId) {
        return;
      }
      this.$http({
        url: '/buz/settlementData/statistics',
        type: 'POST',
        data: {
          reportId: this.reportId,
          ...this.search
        }
      }).then(res => {
        this.statisticsData = res.data;
      });
    },

    // 删除
    delRow(ids) {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry(`确认删除操作？`).then(() => {
        this.$http({
          url: '/buz/settlementData/batchDel',
          type: 'POST',
          data: {
            ids,
            reportId: this.reportId,
            isAll: this.isAll ? 1 : 0,
            ...this.search
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
          this.getStatisticsData();
          this.selectArr = [];
          this.isAll = false;
        });
      });
    },

    // 修改费用
    changeCommission(row) {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.modifyCommissionRef.open(row);
    },

    // 修改扣款
    withholdingCommission(row, flag) {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.commissionModify.open({ ...row, id: row.commissionLogId }, flag);
    },

    // Excel导入结算数据
    importData() {
      const dic = JSON.parse(localStorage.dic)['ORG_NEED_SETTLEMENT_GROUP'];
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        reportId: this.reportId,
        template: key,
        templateName: dic[key],
        uploadUrl: '/buz/settlementData/batch/upload',
        errorUrl: '/buz/settlementData/exportError'
      });
    },

    // 导出
    exportTable(type) {
      if (!this.$units.pointAction('offline_82_3_5')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (!this.reportId) {
        this.$notice.msg('数据未保存，请保存后再导出');
        return;
      }
      if (!this.tableData.length) {
        this.$notice.error('无可导出数据');
        return;
      }
      let params = {
        reportId: this.reportId,
        ...this.search
      };
      if (type == 1) {
        params.needHead = 1;
      }
      this.$units.downloadFile('/buz/settlementData/export', params, 'POST');
    },

    // 批量删除
    batchDelete() {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (!this.isAll && !this.selectArr.length) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.delRow(selectIds);
    },

    // 隐藏收起机构下拉
    mouseLeave(){
      var evt = document.createEvent("MouseEvents");
      evt.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
      document.body.dispatchEvent(evt);
    },

    changeTreeOrg(data) {
      if(this.infoForm.id && this.total) {
        this.mouseLeave();
      }
      if(JSON.stringify(this.orgIds) !== JSON.stringify(data) && this.infoForm.id && this.total) {
        this.$notice.inquiry('结算机构变更，待结算数据可能不属于机构，是否清空？').then(async () => {
          // 确定
          if (data.length) {
            this.$set(this.infoForm, 'orgIds', data);
            if (!this.nextData.settled) {
              this.save(false, 0, true);
            }
          }
        }).catch(()=>{
          // 取消
          this.$set(this.infoForm, 'orgIds', this.orgIds);
        })  
      }      
    },

    // 保存
    save(mark, btn, point = false) {
      if (!this.$units.pointAction('offline_82_3_1') && !point) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.infoFormRef.validate().then(isok => {
        if (!isok) {
          return;
        }
        if (!mark && !btn) {
          this.saveLoading = true;
        }
        if (mark && btn == 1) {
          this.nextStepLoading = true;
        }
        this.$http({
          url: '/buz/settlementReport/saveReport',
          type: 'POST',
          data: {
            id: this.reportId,
            type: 3,
            reportName: this.infoForm.reportName, //结算报表名称
            orgIds: this.infoForm.orgIds, //结算机构id
            settlementDate: filter.filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD'), //结算日期
            remark: this.infoForm.remark, //备注
            step: this.nextData.settled || btn == 1 ? 2 : 1
          }
        }).then(res => {
          this.reportId = res.data.id;
          if (!this.reportId) {
            this.$notice.success('操作成功');
            this.getStatisticsData();
            this.searchAjax();
          }
          if (mark && btn == 2) {
            this.$refs.selectPolicyRef.open(this.infoForm.orgIds);
          } else if (mark && btn == 1) {
            this.nextStep();
          } else if (mark && btn == 4) {
            this.$refs.selectSettlementData.open(this.infoForm.orgIds)
          } else if (!mark && !btn) {
            this.getStatisticsData();
            this.searchAjax();
            this.saveLoading = false;
          } else if (mark && btn == 3) {
            this.importData();
          } else if (mark && btn == 5) {
            this.$refs.selectStatement.open(this.reportId,this.infoForm);
          }
        });
      });
    },

    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },

    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },

    // 下一步
    nextStep() {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/settlementDetails/buildSettlementDetail',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.$emit('next', {
          reportId: this.reportId,
          reportName: this.infoForm.reportName,
          settlementDate: filter.filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD')
        });
        this.nextStepLoading = false;
      }).catch(()=>{
        this.nextStepLoading = false;
      });
    },

    // 已结算下一步
    settledNextStep() {
      this.$emit('next', {
        reportId: this.reportId,
        reportName: this.infoForm.reportName,
        settlementDate: filter.filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD')
      });
    },

    // 展开收起
    foldBtn(val) {
      if (val == 1) {
        this.fold = !this.fold;
      } else {
        this.foldData = !this.foldData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.ivu-dropdown-item{
  display: flex;
  justify-content: center;
}
.btn-reset {
  border: 1px solid #f4f7ff;
  background: #f4f7ff;
  color: #236dff;
}
.item {
  color: #515c6f;
  font-size: 14px;
  margin-left: 20px;
}
.settlement-status {
  position: absolute;
  right: 20px;
  margin-top: 1px;
  margin-left: 20px;
  display: flex;
  .tag-settled {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    color: #e3461f;
    border: 1px solid #ffc1b2;
    background: #fff5f2;
  }
  .tag-be {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    color: #35bf3f;
    border: 1px solid #abeaae;
    background: #f6fcf4;
  }
}
.foldblock {
  margin-bottom: 15px;
  display: inline-block;
  cursor: pointer;
  .title {
    font-size: 16px;
    font-weight: 800;
    margin: 0 10px;
    color: #3c464f;
  }
  .iconColor {
    color: #727c8e;
    margin-right: 2px;
  }
}

.form-container {
  padding: 0 30px;
}

.statistics-container {
  display: flex;
  margin: 10px 0;
  .statistics-item {
    display: flex;
    margin-right: 20px;

    .dot {
      width: 4px;
      height: 4px;
      background: #236dff;
      align-self: center;
      margin-right: 7px;
    }
    .num {
      color: #3c464f;
    }
  }
}

.statistics-box {
  display: flex;
  color: #333;
  margin-bottom: 15px;
  .item {
    margin-left: 60px;
    .num {
      color: #ff7134;
      font-weight: bold;
    }
  }
}

.tableBox {
  margin-top: 10px;
  .name-status {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .user-box {
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-left: 10px;
      .dian {
        display: inline-block;
        flex-shrink: 0;
        width: 5px;
        height: 5px;
        background: #35bf3f;
        border-radius: 50%;
        margin-right: 4px;
        &.red {
          background: #e3461f;
        }
        &.orange {
          background: #ff9900 !important;
        }
      }
      &.text {
        color: #515c6f;
      }
      .user-name {
        font-size: 13px;
        &.dashed {
          border-bottom: 1px dashed #236dff;
        }
        &.line {
          border-bottom: 1px solid #236dff;
        }
      }
      i {
        color: #bababa;
        font-size: 13px;
      }
      .iconduichang {
        margin-left: 4px;
      }
      &.no-token {
        color: #515c6f;
        .user-name {
          cursor: auto;
        }
      }
    }
  }
  .table-btn-disabled {
    cursor: no-drop;
    color: #c5c8ce;
  }
  .commission-price {
    display: flex;
    align-items: center;
    justify-content: center;
    .text-tag {
      margin-left: 5px;
      width: 34px;
      height: 20px;
      border-radius: 2px;
      font-size: 12px;
      color: #ff7f00;
      border: 1px solid #ffcf8e;
      background: #fff3e3;
    }
  }
}
.footer-action {
  position: fixed;
  bottom: 0px;
  background: #fff;
  z-index: 1;
  width: 98%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
</style>
